// src/components/Reports/Summaries/SeoSummary.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const SeoSummary = ({ summary }) => {
    return (
        <Row>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Průměrné SEO skóre</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.averageScore}/100</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Nejčastější problém</h6>
                    <div className="fs-5 fw-bold text-primary">{summary.mostCommonIssue}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Průměrný počet problémů</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.averageIssues}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Celkem nalezených odkazů</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.totalLinks}</div>
                </div>
            </Col>
        </Row>
    );
};

export default SeoSummary;